module.exports = __webpack_public_path__ + "static/img/11.6f9dbe1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/sp/11.png
// module id = m64G
// module chunks = 0